export default [
  {
    position: "absolute",
    top: 20.7,
    left: 58.3,
    class: "dialog",
    animation: "pulsing",
    modalClass: "modal-top-right",
    isDialog: true,
    modal: false,
    mTitle: "personalDetails.persona1.mTitleOne",
    mBody: "personalDetails.persona1.mBodyOne",
    id: "OB_PersonalDetails_Info_NoticeBoard",
    infoIcon: true,
    isAction: false,
    index: 0,
  },
  {
    position: "absolute",
    top: 34.3,
    left: 11.5,
    class: "dialog",
    animation: "pulsing",
    modalClass: "modal-top-left",
    isDialog: true,
    modal: false,
    mTitle: "personalDetails.persona1.mTitleTwo",
    mBody: "personalDetails.persona1.mBodyTwo",
    id: "OB_PersonalDetails_Info_InfoAccess",
    infoIcon: true,
    isAction: false,
    index: 1,
  },
  {
    position: "absolute",
    top: 9.7,
    left: 5.6,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 0,
    tooltipText: "personalDetails.persona1.ttTextOne",
    hover: false,
    id: "OB_PersonalDetails_Navigation_Homepage",
    index: 2,
  },
  {
    position: "absolute",
    top: 6.8,
    left: 60.2,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 4,
    tooltipText: "personalDetails.persona1.ttTextTwo",
    hover: false,
    id: "OB_PersonalDetails_Navigation_Policies",
    index: 3,
  },
  {
    position: "absolute",
    top: 6.8,
    left: 69.2,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 5,
    tooltipText: "personalDetails.persona1.ttTextThree",
    hover: false,
    id: "OB_PersonalDetails_Navigation_Feedback",
    index: 4,
  },
  {
    position: "absolute",
    top: 1,
    left: 87.2,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 8,
    tooltipText: "personalDetails.persona1.ttTextFour",
    hover: false,
    tooltipClass: "left",
    id: "OB_PersonalDetails_Navigation_Actions",
    index: 5,
  },
  {
    position: "absolute",
    top: 66.2,
    left: 16.2,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 2,
    tooltipText: "personalDetails.persona1.ttTextFive",
    hover: false,
    id: "OB_PersonalDetails_Navigation_PersonalDetailsView",
    index: 6,
  },
  {
    position: "absolute",
    top: 66.2,
    left: 89.2,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 3,
    tooltipText: "personalDetails.persona1.ttTextSix",
    hover: false,
    tooltipClass: "left",
    id: "OB_PersonalDetails_Navigation_PassportInformation",
    index: 7,
  },
];
